tasks-delivered-cell
  .memos
    tasks-delivered-count(each="{empty, index in this.number}" tag-scope="{this.genTagScopeForDeliveryRecord(index)}" data-index="{index}")
  script(type="typescript").
    this.mixin('tasks.delivered-cell');
